import React from 'react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './page-shell.css'

const LegalPrivacy = () => {
  return (
    <div className="page-shell">
      <Helmet>
        <title>MDMC Privacy</title>
        <meta property="og:title" content="MDMC Privacy" />
      </Helmet>
      <Navigation></Navigation>
      <main>
        <section className="page-hero">
          <h1 className="page-hero-title">Privacy Policy</h1>
          <p className="page-hero-subtitle">
            What MDMC.dev collects from public tools, forms, and operator access
            requests.
          </p>
        </section>
        <div className="page-panel">
          <h3>Data You Submit</h3>
          <p>
            Forms may collect your email, name, project details, page URL, and
            referrer so the team can respond to client staging, operator access,
            newsletter, or experiment requests.
          </p>
        </div>
        <div className="page-panel">
          <h3>Public Tool Data</h3>
          <p>
            The meme generator sends selected template and caption text to the
            rendering service used for public image generation. Do not enter
            secrets, private client material, or anything that should not leave
            your browser.
          </p>
        </div>
        <div className="page-panel">
          <h3>Cookies And Analytics</h3>
          <p>
            MDMC.dev may use basic logs, analytics, and anti-abuse signals to
            understand traffic and keep the site reliable. We do not need
            sensitive personal data to run the public library or generator.
          </p>
          <div className="page-cta">
            <a className="btn btn-primary" href="/legal/terms">Read Terms</a>
            <a className="btn btn-secondary" href="https://tx.wtf" target="_blank" rel="noopener noreferrer">Join tx.wtf</a>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  )
}

export default LegalPrivacy

